import { ReactQueryDevtools as ReactQueryDevtoolsCore } from '@tanstack/react-query-devtools';
import { environment } from '../../environments/environment';

export const ReactQueryDevtools = () => {
  if (environment.env === 'development') {
    return <ReactQueryDevtoolsCore initialIsOpen={false} />;
  }

  return null;
};
